<template>
    <ul class="nav avp-meta-navigation">
        <li class="nav-item"><a href="https://www.animod.de/c/impressum" target="_blank" rel="noopener" class="nav-link">Impressum</a></li>
        <li class="nav-item"><a href="https://www.animod.de/c/agb" target="_blank" rel="noopener" class="nav-link">AGB</a></li>
        <li class="nav-item"><a href="https://www.animod.de/c/datenschutz" target="_blank" rel="noopener" class="nav-link">Datenschutzerklärung</a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'CardFooter',
        data: function () {
            return {
            };
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .avp-meta-navigation {
        justify-content: center;

        .nav-link {
            padding: 1rem;
            text-decoration: underline;
            transition: color 0.5s ease;

            &:link {
                color: #ccc;
            }

            &:hover {
                color: lighten(#ccc, 25%);
            }

            &:active {
                color: lighten(#ccc, 50%);
            }

            &:visited {
                color: darken(#ccc, 10%);
            }
        }
    }
</style>
